import { Component, Input, OnInit, inject } from '@angular/core';
import { combineLatest, filter, map, Observable, of, switchMap } from 'rxjs';
import { UrlSafePipe, UrlTargetPipe } from '@boels/helpers';
import {
  BackgroundColorEnum,
  BoelsBaseSite,
  BoelsCmsLinkComponent,
  BoelsTeaserComponentData,
} from '@boels/models';

import { GenericLinkComponent } from '../generic-link/generic-link.component';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import {
  CatalogsFacade,
  CultureFacade,
  SiteContextFacade,
} from '@boels/shared-state';

@Component({
  imports: [
    GenericLinkComponent,
    FontAwesomeModule,
    CommonModule,
    UrlTargetPipe,
  ],
  selector: 'boels-generic-link-wrapper',
  templateUrl: './generic-link-wrapper.component.html',
})
export class GenericLinkWrapperComponent implements OnInit {
  private catalogsFacade = inject(CatalogsFacade);
  private urlSafePipe = inject(UrlSafePipe);
  private cultureFacade = inject(CultureFacade);
  private siteContextFacade = inject(SiteContextFacade);

  @Input() componentData: BoelsTeaserComponentData;
  @Input() isExternal: boolean | undefined;
  @Input() arrowType: IconDefinition;
  @Input() showArrow: boolean;
  @Input() applyClass: string;
  @Input() link: BoelsCmsLinkComponent | undefined;
  @Input() showLink = true;
  iconType = faArrowRight;
  backgroundColor = BackgroundColorEnum;
  categoryLinkData: Observable<string[]>;
  categoryCode: string | undefined;
  productCode: string | undefined;

  ngOnInit(): void {
    if (!this.link) {
      this.link = this.componentData?.link as BoelsCmsLinkComponent;
    }
    if (this.link?.category) {
      this.categoryCode = this.link?.category;
      this.categoryLinkData = combineLatest([
        this.cultureFacade.getActiveCulture(),
        this.siteContextFacade.getActiveBaseSiteEntity(),
      ]).pipe(
        filter(([, baseSite]) => !!baseSite?.uid),
        switchMap(([culture, baseSite]: [string, BoelsBaseSite]) => {
          if (baseSite.uid && this.link?.category) {
            return this.catalogsFacade.getCategoryForId(
              baseSite.uid,
              culture,
              this.link?.category,
            );
          }

          return of(undefined);
        }),
        filter(Boolean),
        map((cat) => {
          const urlParts = [];
          for (const breadCrumb of cat?.boelsBreadcrumbs || []) {
            urlParts.push(this.urlSafePipe.transform(breadCrumb.categoryName));
          }
          urlParts.push(this.urlSafePipe.transform(cat?.name));
          urlParts.push('c');
          urlParts.push(cat?.id);
          return urlParts.filter((part) => part !== undefined);
        }),
      );
    }
  }
}
